// extracted by mini-css-extract-plugin
export default {"container":"Switch_container__kXIU8","label":"Switch_label__LBx1d","switch":"Switch_switch__aQe3-","active":"Switch_active__A9wCI"};